import Vue from 'vue';
import App from './App.vue';
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/fontawesome/css/all.min.css';
import './css/styles.css';

Vue.config.productionTip = false;

// Vue Application
new Vue({
  render: h => h(App),
}).$mount('#app');

// Javascript declarations
$('[data-toggle="tooltip"]').tooltip({
  trigger: 'hover'
})